module.exports = __webpack_public_path__ + "static/media/rollerblade3.267db7d0.gif";